import { jsx as _jsx } from "react/jsx-runtime";
import { translate } from "../../helpers/i18n";
export default function MapOverlayLogo() {
    return (
    // eslint-disable-next-line react/jsx-no-target-blank
    _jsx("a", { className: "ms3-logo", href: "https://www.neonaut.de/", target: "_blank", children: _jsx("span", { className: "ms3-visuallyhidden", children: translate("ui.map-overlay.logo.copyright") }) }));
}
